"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBox = void 0;
var React = __importStar(require("react"));
var CheckBox = function (props) {
    var labelText = props.labelText, isSelected = props.isSelected, onClick = props.onClick, hasError = props.hasError, validationMessage = props.validationMessage;
    var error = hasError ? React.createElement("div", { className: "checkbox has-error" }, validationMessage) : null;
    var onChange = function (ev) {
        !!ev.target && onClick(ev.target.checked);
    };
    return (React.createElement("label", { className: "checkbox-wrapper" },
        React.createElement("input", { type: "checkbox", onChange: onChange, checked: isSelected }),
        React.createElement("span", { className: "checkbox-control checked-".concat(isSelected) }),
        React.createElement("span", { className: "checkbox-title" }, labelText),
        error));
};
exports.CheckBox = CheckBox;
